import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { KeyValuePair } from '../../../shared/key-value-pair';
import { StateConstants } from '../../../shared/constants/state-constants';
import { State } from '../../../shared/constants/state';
import { ContactConstants } from '../../../shared/constants/contact-constants';
import { FormValidation } from '../../../shared/form-validation';

@Component({
  selector: 'claim-repair-facility',
  templateUrl: './claim-repair-facility.component.html',
})
export class ClaimRepairFacilityComponent implements OnInit {

  public claimRepairFacilityForm: UntypedFormGroup;
  public manualKeyValuePairs: KeyValuePair[] = [{ key: "Mitchell", value: "Mitchell" }, { key: "AllData", value: "AllData" }, { key: "Motors", value: "Motors" }, { key: "Other", value: "Other" }];
  public formCompleted: boolean = false;
  public states: State[] = [];
  public contactMethods: KeyValuePair[] = ContactConstants.ContactOptions;

  constructor() { }

  ngOnInit(): void {
    this.getStates();
    this.populateData();
  }

  public getStates(): void {
    this.states = StateConstants.GetAllUsStates();
  }

  public populateData() {
    this.claimRepairFacilityForm = new UntypedFormGroup({
      'repairFacilityName': new UntypedFormControl("", [Validators.required]),
      'emailAddress': new UntypedFormControl("", [Validators.required, Validators.email]),
      'streetAddress1': new UntypedFormControl("", [Validators.required]),
      'streetAddress2': new UntypedFormControl(),
      'city': new UntypedFormControl("", [Validators.required]),
      'state': new UntypedFormControl("", [Validators.required]),
      'zip': new UntypedFormControl("", [Validators.required]),
      'laborRatePerHour': new UntypedFormControl("", [Validators.required]),
      'laborManualUsed': new UntypedFormControl(),
      'phoneNumber': new UntypedFormControl("", [Validators.required]),
      'preferredPaymentMethod': new UntypedFormControl(),
      'repairFacilityPreferredContactMethod': new UntypedFormControl(this.contactMethods.find(x => x.value === ContactConstants.EMAIL).value, [Validators.required]),
      'repairFacilityContactName': new UntypedFormControl(),
    });
  }

  public validateForm(): void {
    this.formCompleted = FormValidation.isValid(this.claimRepairFacilityForm);
  }
}